import logo from './logo.svg';
import './App.css';
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
 import PublicProfilePage from './pages/PublicProfilePage';
 import { Toaster } from 'react-hot-toast';
import OnboardingPage from './pages/OnboardingPage';
import LandingPage from './pages/LandingPage'
// import './assets/css/App.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>

        {/* Toater global - solo una vez en toda la app */}
        <Toaster
          position="top-center"
          reverseOrder={false}
          gutter={8}
          containerClassName=""
          containerStyle={{}}
          toastOptions={{
            // Default options
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
              padding: '16px',
              borderRadius: '8px',
              fontSize: '14px',
            },
            // Opciones por tipo
            success: {
              duration: 3000,
              icon: '✅',
              style: {
                background: '#10b981',
              },
            },
            error: {
              duration: 4000,
              icon: '❌',
              style: {
                background: '#ef4444',
              },
            },
            loading: {
              icon: '⏳',
              style: {
                background: '#6b7280',
              },
            },
          }}
        />

        <Routes>
          <Route path="/login" element={<LandingPage />} />
          <Route path="/dashboard/*" element={<DashboardPage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/:username" element={<PublicProfilePage />} />
          <Route path="/" element={<LandingPage />}  />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
